<div class="relative isolate h-full w-full flex flex-col p-2 sm:p-6">

    <div class="mx-auto max-w-7xl w-full h-full flex flex-col gap-y-2 sm:gap-y-4 items-start overflow-hidden">
        <div aria-hidden="true"
            class="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl">
            <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                class="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"></div>
        </div>
        <!-- Stepper -->
        <div class="shrink-0 w-full flex flex-col py-2 gap-y-2 sm:gap-y-4">
            <div class="w-full flex flex-row items-center justify-between">
                <span class="relative flex flex-row items-center justify-start gap-x-4">
                    <button (click)="goBack()" type="button" class="btn-fab-secondary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <div class="w-full flex justify-start items-center">
                        <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_black.svg"
                            class="h-6 sm:h-10 w-auto dark:hidden" alt="">
                        <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_white.svg"
                            class="h-6 sm:h-10 w-auto hidden dark:block" alt="">
                    </div>
                </span>

                <p class="text-sm font-medium text-secondary">
                    Step {{ currentStep() }} of 7
                </p>
            </div>

            <div class="w-full flex flex-row items-center justify-between">
                <div class="w-full flex flex-row items-center justify-start gap-2">
                    @for (step of steps; track step.id) {
                    <div (click)="currentStep.set(step.id)" class="flex-1 h-2 rounded-full"
                        [class]="getStepBarClass(step)">

                    </div>
                    }
                </div>
            </div>
        </div>
        <!-- Stepper END -->


        <!-- Content -->
        <div class="flex-1 min-h-0 flex flex-col w-full overflow-hidden">

            @if (showGeneralLoader()) {
            <div
                class="w-full h-full min-h-0 flex flex-col items-center justify-center flex-1 overflow-y-auto scrollbar-transparent rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 outline -outline-offset-1 outline-gray-300 dark:outline-white/10">
                <div class="content h-full w-full flex items-center justify-center">
                    <div class="flex flex-col items-center justify-center">

                        <div class="w-[30dvw] overflow-hidden">
                            <div class="px-4 py-5 sm:p-6 flex flex-col items-center justify-center">
                                <atom-loading-inline title="Creating your account..."
                                    message="This may take a few seconds..."></atom-loading-inline>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            } @else {
            @switch (currentStep()) {
            @case (1) {
            <v2-user-details (stepComplete)="nextStep($event, 1)"></v2-user-details>
            }
            @case (2) {
            <oba-agency-details (stepComplete)="agencyDetailsStepComplete($event, 2)"></oba-agency-details>
            }
            @case (3) {
            <oba-agency-brands (stepComplete)="nextStep($event, 3)"></oba-agency-brands>
            }
            @case (4) {
            <oba-agency-congrats></oba-agency-congrats>
            }
            }
            }
        </div>
        <!-- Content - END -->

        <div aria-hidden="true"
            class="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:-top-112 sm:ml-16 sm:translate-x-0">
            <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                class="aspect-1097/845 w-274.25 bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"></div>
        </div>

    </div>

</div>